import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import React from "react";
import {useCopyrightDispatch} from "../copyrightContext";
import PropTypes from "prop-types";

/**
 * Button used when adding a license or a copyright clause.
 * @param label
 * @param dispatchValue
 * @returns {JSX.Element}
 * @constructor
 */
const BtnAdd = ({label, dispatchValue}) => {
    const copyrightDispatch = useCopyrightDispatch();
    return <Button
        sx={{
            marginBottom: 2
        }}
        startIcon={<AddIcon size={"small"}/>}
        variant={'text'}
        color={"secondary"}
        onClick={() => {
            copyrightDispatch({
                type: dispatchValue
            });
        }
        }
    >
        {label}
    </Button>;
};

BtnAdd.propTypes = {
    label: PropTypes.string.isRequired,
    dispatchValue: PropTypes.string.isRequired
};

export {BtnAdd};
